import styled from 'styled-components';
import {
  ButtonBase,
  SectionHeader,
  FlexCentered,
  PrimaryLink,
} from '../../../../../stories/components/CommonStyleUtils/dwebCommon.styles';
import SearchInputIcon from '../../../../../stories/Icons/SearchInputIcon';
import Image from '../../../../../stories/components/hotels/common/Image/Image';
import {headingSizes, textSizes} from '@stencil/build-theme';

export const LocationMapContainer = styled.section(
  props => `
  width: 100%;
  margin: ${props.theme.spacing.xxlarge} auto 0;
  max-width: 120rem;
  border: 1px solid ${props.theme.colors.goBrandBlue.light};
  border-radius: ${props.theme.misc.borderRadius.xxxlarge};
  background: ${props.theme.colors.goWhite.base};
`,
);

export const LocationMapHeader = styled.div(
  props => `
  border-bottom: 0.1rem solid ${props.theme.colors.ash.dark};
  padding: ${props.theme.spacing.xlarge} ${props.theme.spacing.xxlarge};
`,
);

export const LocationSubTextPara = styled.p(
  props => `
  display:flex;
  padding-top:${props.theme.spacing.small};
  align-items:center;
  font-size: 1.4rem;
`,
);

export const SubTextSpan = styled.span(
  props => `
  font-size: ${props.theme.font.custom(16)};
`,
);
export const LocationRating = styled.span`
  ${textSizes.BaseW3}
  background:#148730;
  border-radius: 4px;
  align-items: center;
  color: ${props => props.theme.colors.goWhite.base};
  padding: ${props => props.theme.spacing.custom(2)} ${props => props.theme.spacing.small};
  margin-left: ${props => props.theme.spacing.base};
`;

export const LocationMapNewSection = styled.section`
  display: flex;
  padding: 2rem 2.5rem;
  height: 42rem;
  position: relative;
  ${props =>
    props.isExpand &&
    `
    width: 100%;
    height: 100%;
    position: fixed;
    left: 0;
    top: 0;
    background: #fff;
    z-index: 100;
    padding:0;
  `}
`;
export const MapLeft = styled.div(
  props => `
    flex: 1;
    position: relative;
    margin-right: ${props.theme.spacing.xlarge};
  `,
);
export const MapRight = styled.div(
  props => `
    width: 340px;
    flex-shrink: 0;
    background: #fff;
    display: flex;
  `,
);
export const HeaderLocationDiv = styled.div`
  ${textSizes.BaseW3}
  display:flex;
  background: #f4f7fa;
  padding: 1.5rem;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
`;

export const MapImg = styled(Image)(
  props => `
    width: 100%;
    object-fit: cover;
    height: 100%;
    border-radius:12px;
  `,
);
export const RightOuterContainer = styled.span(
  props => `
    width:100%;
    display: flex;
    flex-direction: column;
    border: 1px solid ${props.theme.colors.goBrandBlue.light};
    border-radius: 12px;
    overflow-y: hidden;
    `,
);

export const ExpandInnerWrapperDiv = styled.div(
  props => `
    user-select: none;
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.11);
    border-radius: 12px;
    cursor: pointer;
    background-color: rgb(255, 255, 255);
    width: 6rem;
    height: 6rem;
    display:flex;
    align-items: center;
    justify-content: center;
      `,
);
export const AddressLocator = styled.span(
  props => `
    position: absolute;
    top: 222px;
    right: 236px;
    cursor: pointer;
    `,
);
export const PropertyNameText = styled.span`
  ${headingSizes.Base}
`;

export const SearchBar = styled.div(
  props => `
  position: absolute;
  left:33px;
  top: 23px;
  user-select: none;
  z-index:1;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.11);
  border-radius: 12px;
  background-color: rgb(255, 255, 255);
  width: 45rem;
  height: 5.8rem;
  padding:15px 20px;
  display:flex;
  align-items: center;
  justify-content:space-between;
    `,
);
export const SearchNearByLocation = styled.div(
  props => `
  display:flex;
  border: .1rem solid ${props.theme.colors.goBrandBlue.light};
  padding:${props.theme.spacing.large};
  border-radius: ${props.theme.misc.borderRadius.custom(12)};
  margin: ${props.theme.spacing.xxlarge} ${props.theme.spacing.xxlarge} 0 ${
    props.theme.spacing.xxlarge
  };
  box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.14);
`,
);
export const LocationSearchInput = styled.input(
  props => `
  width:100%;
  border:none;
  font-size: ${props.theme.font.large};
  background-color:${props.theme.colors.goWhite.base};
  ::placeholder {
    color: ${props.theme.colors.downriver.medium};
    font-size: ${props.theme.font.custom(16)};
    overflow:visible;
  }
  &:focus{
    box-shadow: none;
    outline-offset: 0;
    outline: 0;
  }
  `,
);
export const SearchIconWrap = styled(SearchInputIcon)(
  props => `
  width:2rem;
  height:2rem;
  margin-right: ${props.theme.spacing.large};
  fill:${props.theme.colors.downriver.medium};
  margin-top:${props.theme.spacing.custom(3)};
`,
);
export const AutosuggestWraper = styled.div(
  props => `
  position: absolute;
  right: 0;
  top: 49px;
  background-color: rgb(255, 255, 255);
  width: 45rem;
  max-height: 24rem;
  flex-direction: column;
  li{
    display:flex;
    flex-direction: column;
    // padding-bottom:${props.theme.spacing.large};
    padding:${props.theme.spacing.custom(12)} ${props.theme.spacing.custom(
      12,
    )} 0 ${props.theme.spacing.custom(12)};

    &:last-child{
        padding:${props.theme.spacing.custom(12)};
    }
    &:first-child{
      border-top:2px solid #eef4fd;
    }
}

    `,
);
export const PointerSpan = styled.span(
  props => `
  position: absolute;
  right: 34%;
  bottom: 350px;
  width:2rem;
  height:2rem;
  background-color:#ff3a5c;
  border-radius:50%;

    `,
);
export const PointerTipTextDiv = styled.span(
  props => `
  width: 21rem;
	position: relative;
  background-color: #ff3a5c;
  border-radius: 1.5rem;
  padding: 15px 18px;
  text-align:center;
  color:white;
  &::after {
    bottom: 100%;
    left: 21%;
    border: solid transparent;
    content: " ";
    height: 0;
    width: 0;
    position: absolute;
    pointer-events: none;
    border-color: transparent transparent #ff3a5c transparent ;
    // border-top-color: #ff3a5c ;
    border-width: 15px;
    margin-left: -8px;
  }

`,
);
export const PointerWrapper = styled.div(
  props => `
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    position: absolute;
    top: 75%;
    right: 148px;
    cursor: pointer;
    z-index: 1;
    `,
);

// AutoSugguestOuterDiv

export const AutoSuggestOuterWrapper = styled.div(
  props => `
  display:flex;
  margin: 0 ${props.theme.spacing.xxlarge} ${props.theme.spacing.xxlarge};
  position:relative;
`,
);
export const AutoSuggestContainer = styled.div(
  props => `
  position:relative;
  width:28.6rem;
  padding: ${props.theme.spacing.small} ${props.theme.spacing.base};
  margin-right: ${props.theme.spacing.base};
  border-radius: ${props.theme.misc.borderRadius.large};
  background:${props.theme.colors.goBrandBlue.light};
  border: .2rem solid ${props.theme.colors.goBrandBlue.light};
`,
);
export const TimeDistanceDurationWrapper = styled.div(
  props => `
  padding-top:${props.theme.spacing.base};
`,
);
export const LocationNameToolTip = styled.span(
  props => `
  visibility: hidden;
  background-color: ${props.theme.colors.downriver.medium};
  color: ${props.theme.colors.goWhite.base};
  border-radius: ${props.theme.misc.borderRadius.large};
  padding: ${props.theme.spacing.small} ${props.theme.spacing.base};
  /* Position the tooltip */
  position: absolute;
  left:1.5rem;
  top:3rem;
  z-index:1;
`,
);
export const LocationName = styled.div(
  props => `
  color: ${props.theme.colors.goBrandBlue.base};
  font-size: ${props.theme.font.custom(14)};
  font-weight: 600;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  width:22rem;
  cursor:pointer;
  &:hover > ${LocationNameToolTip} {
    visibility: visible;
  }
`,
);
export const LocationMapWrapper = styled(FlexCentered)(
  props => `
  padding-top:${props.theme.spacing.small};
`,
);
export const TimeDuration = styled.span(
  props => `
  color: ${props.theme.colors.downriver.medium};
  font-size: ${props.theme.font.custom(14)};
`,
);
export const DistanceDuration = styled(TimeDuration)(
  props => `
  padding-right: ${props.theme.spacing.small};
`,
);

export const SomethingWentWrongText = styled(SectionHeader)(
  props => `
  padding-bottom:${props.theme.spacing.large};
  margin-left:${props.theme.spacing.xlarge};
`,
);

export const ReloadBtn = styled(ButtonBase)(
  props => `
  border: 0.1rem solid ${props.theme.colors.goBrandBlue.base};
  background:${props.theme.colors.goWhite.base};
  color: ${props.theme.colors.goBrandBlue.base};
  padding: ${props.theme.spacing.base} 0 ;
  width: 45%;
  margin-left:${props.theme.spacing.xlarge};
  &:hover{
    background:${props.theme.colors.goBrandBlue.base};
    color:${props.theme.colors.goWhite.base};
  }
  font-size:${props.theme.font.base};
`,
);

// To be removed, for the sake of old compatibility
export const MapActionButton = styled(ButtonBase)(
  props => `
  padding: ${props.theme.spacing.base} ${props.theme.spacing.large};
  background: white;
  color: black;
  box-shadow: ${props.theme.colors.downriver.medium} 0px 1px 4px -1px;
  font-size:${props.theme.font.base};
`,
);

export const MapActionButtonContainer = styled.div(
  props => `
  position: absolute;
  top: ${props.isExpand ? '9rem' : '4rem'};
  z-index: ${props.theme.misc.zIndex.small};
  left:${props.isExpand ? '3.3rem' : '4.5rem'};
`,
);

export const ClearSearchText = styled(PrimaryLink)(
  props => `
  width:2rem;
  height:3rem;
  margin-right: ${props.theme.spacing.large};
  `,
);

export const GoogleStaticImageContainer = styled.div(
  props => `
  background-image: url(${props.hotelImage || 'https://goibibo-nodejs-bucket.s3.amazonaws.com/avatar/mapEntryHover.avif?downsize=672:519&crop=672:519'});
  background-size: cover;
  background-repeat: no-repeat;
  height: 100%;
  width: 100%;
  filter: blur(3px);
`,
);

export const LoadMapButton = styled.div`
  align-items: center;
  background-color: #fff;
  border: 1px solid #008cff;
  border-radius: 8px;
  color: #008cff;
  cursor: pointer;
  display: flex;
  font-family: Lato, sans-serif;
  font-size: 12px;
  font-weight: 900;
  justify-content: center;
  left: 50%;
  line-height: 14px;
  outline: 0;
  padding: 10px 20px;
  position: absolute;
  top: 50%;
  transform: translate(-50%, -50%);
  z-index: 1;
`;
